import type * as React from 'react'

import { DropdownMenu } from '@buffer-mono/popcorn'

import styles from './BulkActionsMenuContent.module.css'

import type { JSX } from 'react'

export type BulkActionsMenuContentProps = {
  children: React.ReactNode
}

export function BulkActionsMenuContent({
  children,
}: BulkActionsMenuContentProps): JSX.Element {
  return (
    <DropdownMenu.Content data-no-focus-lock className={styles.content}>
      {children}
    </DropdownMenu.Content>
  )
}
